var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import SVG from 'react-svg';
export default class CardHeader extends PureComponent {
    render() {
        const _a = this.props, { svgName, svgUrl } = _a, rest = __rest(_a, ["svgName", "svgUrl"]);
        let url;
        if (svgUrl) {
            url = svgUrl;
        }
        else if (svgName) {
            url = `https://static.ux.cimpress.io/assets/icons/${svgName}.svg`;
        }
        return (React.createElement("div", Object.assign({ style: { padding: '8.5px 1px', maxWidth: '220px', margin: '0 auto', textAlign: 'center', position: 'relative' } }, rest),
            React.createElement(SVG, { path: "https://static.ux.cimpress.io/assets/icons/card_icon_bg.svg" }),
            React.createElement(SVG, { path: url, style: {
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: '24px',
                    height: '24px',
                } })));
    }
}
CardHeader.propTypes = {
    svgUrl: PropTypes.string,
    svgName: PropTypes.string,
};
